import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
interface CountdownProps {
  initialHours?: number;
  initialMinutes?: number;
  initialSeconds?: number;
  className?: string;
}
export function Countdown({
  initialHours = 23,
  initialMinutes = 59,
  initialSeconds = 46,
  className = ''
}: CountdownProps) {
  const [timeLeft, setTimeLeft] = useState(() => {
    return initialHours * 3600 + initialMinutes * 60 + initialSeconds;
  });
  useEffect(() => {
    if (timeLeft <= 0) return;
    const intervalId = setInterval(() => {
      setTimeLeft(prev => Math.max(0, prev - 1));
    }, 1000);
    return () => clearInterval(intervalId);
  }, [timeLeft]);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  const Unit = ({
    value,
    label,
    animate = false
  }: {
    value: number;
    label: string;
    animate?: boolean;
  }) => <div className="flex flex-col items-center" data-id="element-65">
      <div className="relative" data-id="element-66">
        {/* Glow */}
        <div className="absolute inset-0 bg-optic/40 blur-xl rounded-xl" data-id="element-67"></div>
        <div className="relative bg-gradient-to-b from-navy-800 to-navy-900 border-2 border-optic/60 text-optic px-3 py-2.5 md:px-4 md:py-3 rounded-xl shadow-2xl min-w-[3.25rem] md:min-w-[4.25rem] text-center overflow-hidden" data-id="element-68">
          {/* Top sheen */}
          <div className="absolute top-0 left-0 right-0 h-1/2 bg-white/5 pointer-events-none" data-id="element-69"></div>
          <AnimatePresence mode="popLayout" initial={false} data-id="element-70">
            <motion.span key={value} initial={animate ? {
            y: -20,
            opacity: 0
          } : false} animate={{
            y: 0,
            opacity: 1
          }} exit={animate ? {
            y: 20,
            opacity: 0
          } : undefined} transition={{
            duration: 0.25
          }} className="relative block font-display text-2xl md:text-4xl tracking-tight tabular-nums" data-id="element-71">
              {formatNumber(value)}
            </motion.span>
          </AnimatePresence>
        </div>
      </div>
      <span className="text-[9px] md:text-[10px] uppercase mt-1.5 tracking-[0.15em] font-bold text-white/80" data-id="element-72">
        {label}
      </span>
    </div>;
  const Colon = () => <motion.span animate={{
    opacity: [1, 0.3, 1]
  }} transition={{
    duration: 1,
    repeat: Infinity,
    ease: 'easeInOut'
  }} className="text-optic font-display text-2xl md:text-4xl self-start mt-1 md:mt-2" data-id="element-73">
      :
    </motion.span>;
  return <div className={`flex items-center gap-1.5 md:gap-2.5 ${className}`} data-id="element-74">
      <Unit value={hours} label="Horas" data-id="element-75" />
      <Colon data-id="element-76" />
      <Unit value={minutes} label="Min" data-id="element-77" />
      <Colon data-id="element-78" />
      <Unit value={seconds} label="Seg" animate data-id="element-79" />
    </div>;
}